<div class="main-container">
    <app-toast-message></app-toast-message>
    <app-loader></app-loader>
    <router-outlet></router-outlet>
</div>